export { default } from "./Acquiring";



// WEBPACK FOOTER //
// ./src/containers/Private/pages/workflow-client/pages/Acquiring/index.js